export const genders = [ //An array of each Race's ID, atlas, and name. There are 2.
  {
    id: 'vb', //For gender, append ?? to find class of div.
    atlas: 'atlas02',
    name: 'Male' //Show name in textbox.
  },
  {
    id: 'vg',
    atlas: 'atlas09',
    name: 'Female'
  },
]